<template>
	<div class="main custom">
		<div class="g-mnc g-mnc-kefu">
			<div class="sidebar">
				<div class="service-content">
					<div class="u-sideBar-title">客户</div>

					<ul class="tabs">
						<li
							:class="item.class"
							@click="cutover(menus,index)"
							v-for="(item,index,) in menus"
						>{{item.message}}</li>
					</ul>
				</div>
			</div>
			<div class="content">
				<div :is="movement"></div>
			</div>
		</div>
	</div>
</template>

<script>
import lable from '@/components/manage/client/lable'
import management from '@/components/manage/client/management'
export default {
	name: 'custom',
	props: [],
	data() {
		return {
			movement: 'management',
			menus: [
				{
					class: 'current',
					message: '客户管理'
				},
				{
					class: '',
					message: '客户标签'
				}
			]
		}
	},
	watch: {},
	mounted: function() {},
	methods: {
		cutover(menus, index) {
			//console.log(menus)
			for (let i = 0; i < menus.length; i++) {
				menus[i].class = ''
			}
			menus[index].class = 'current'
			if (index == 0) {
				this.movement = 'management'
			} else {
				this.movement = 'lable'
			}
		}
	},
	components: {
		lable,
		management
	}
}
</script>

<style scoped>
.main {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: calc(100% - 65px);
	position: relative;
	background-color: #fff;
}
.g-mnc {
	display: flex;
	flex: 1;
	flex-direction: row;
	padding: 40px;
	box-sizing: border-box;
}
.g-mnc-kefu {
	position: relative;
	-moz-border-radius: 2px;
	border-radius: 2px;
	box-sizing: border-box;
	flex-direction: column;
	height: calc(40%);
	padding: 0 0 0 0px;
	display: flex;
	flex-direction: row;
}

.g-mnc-kefu .sidebar {
	height: 100%;
}
.service-content {
	width: 130px;
	transition: width 0.2s;
	background: #f7f8fa;
	overflow-x: hidden;
	overflow-y: auto;
	height: 100%;
}
.g-mnc-kefu .content {
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	position: relative;
	/* padding: 0 30px; */
	padding-left: 30px;
	padding-top: 10px;
	width: 100%;
	box-sizing: border-box;
}
.u-sideBar-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 18px;
	color: #222;
	padding: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.tabs li {
	background-color: #f7f8fa;
	line-height: 50px;
	padding-left: 20px;
}
.tabs li.current {
	background-color: #edeef0;
	color: #337eff;
	border-right: 3px solid #337eff;
}
/*子菜单*/
.el-menu {
	background-color: #f7f8fa;
}
.is-active {
	background-color: #edeef0;
	border-right: 3px solid #337eff;
}
/**/
.contains {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	padding-top: 10px;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.content-tit {
	height: 60px;
	line-height: 46px;
}
.content-tit h2 {
	font-weight: normal;
	font-size: 24px;
}
.content-main {
	display: flex;
	position: relative;
	/* height: calc(100% - 60px);*/
	height: 100%;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/custom/custom.vue